// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryMedicalPayor {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryMedicalPayor.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryMedicalPayor.discriminator = undefined;
MangoHubGetPatientSummaryMedicalPayor.attributeTypeMap = [
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "group",
        "baseName": "group",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "planTypeDescription",
        "baseName": "planTypeDescription",
        "type": "string"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<MangoHubPhone>"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<MangoHubAddress>"
    }
];
//# sourceMappingURL=mangoHubGetPatientSummaryMedicalPayor.js.map